import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-recurring-rule',
  templateUrl: './recurring-rule.component.html',
  styleUrls: ['./recurring-rule.component.scss']
})
export class RecurringRuleComponent implements OnInit {
  public daysList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  public day = this.daysList[0]
  public weekList = ['00','01', '02', '03', '04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23']
  public weekOneList = ['00','5', '10', '15', '20','25','30','35','40','45','50','55']
  public week = this.weekList[0]
  public weekOne = this.weekOneList[0]
  public description = ''
  public isCheck = false
  public hours = ''
  public isDescErr = false
  public isHoursErr =false
  public recurringRes: any;
  public globalServicesId = 0;
  public serviceName = '';
  public enabledValue = 0;
  public userId = '';
  public editServiceId = 0
  public isEdit = false;
  public recuringResponse: any;
  constructor(private router: Router, private service: ApifirstService) { }

  ngOnInit(): void {
    this.service.globalServicesId.subscribe(data => {
      this.globalServicesId = data
    })

    this.service.editServiceId.subscribe(data => {
      this.editServiceId = data
    })
    this.service.isEditRecurringRule.subscribe(data => {
      this.isEdit = data;
    })
    this.service.recurringRes.subscribe(data => {
      this.recuringResponse = data
    })

    this.service.serviceName.subscribe(data => {
      this.serviceName = data
    })
    this.service.userId.subscribe(data => {
      this.userId = data
    })
    if (this.isEdit) {
      this.description = this.recuringResponse.description
      this.day = this.recuringResponse.weektime
      let time=this.recuringResponse.est_start.split(":")
      this.week=time[0]
      this.weekOne=time[1]
      this.hours=this.recuringResponse.duration_mins
      if(this.recuringResponse.enabled == 1){
        this.isCheck =true;
      }else{
        this.isCheck =false;
      }
    }
  }

  add() {
    const pattern = new RegExp("^[0-9.]+$");
    if (this.description == "" || this.description == undefined || this.description == null) {
      this.isDescErr = true;
    } else {
      this.isDescErr = false;
    }
      if (this.hours == "" || this.hours == undefined || this.hours == null) {
        this.isHoursErr = true;
      } else if (pattern.test(this.hours)){
        this.isHoursErr = false;
      } else {
        this.isHoursErr = false;
      }
    if (this.isCheck) {
      this.enabledValue = 1
    } else {
      this.enabledValue = 0
    }
    var z: number = +this.hours;
    var user: number = +this.userId;
    let req={}
    if(this.isEdit) {
     req = {
        "id": this.recuringResponse.id,
        "serviceid": this.globalServicesId,
        "description": this.description,
        "type": 0,
        "user_id": user,
        "duration_mins": z,
        "enabled": this.enabledValue,
        "recurring": "Recurring Rule",
        "weektime": this.day,
        "est_start": this.week + ":" +this.weekOne,
        "est_end": null
      }
      if (!this.isDescErr && !this.isHoursErr) {
        this.service.ruleUpdateApi(req).subscribe(data => {
          this.recurringRes = data;
          this.service.recurringRes.next(this.recurringRes)
          this.router.navigate(['admin/showRules']);
        })
      }
      
    } else {
        req = {
        "serviceid": this.globalServicesId,
        "description": this.description,
        "type": 0,
        "user_id": user,
        "duration_mins": z,
        "enabled": this.enabledValue,
        "recurring": "Recurring Rule",
        "weektime": this.day,
        "est_start": this.week + ":" +this.weekOne,
        "est_end": null
      }
      if (!this.isDescErr && !this.isHoursErr) {
        this.service.recurringRule(req).subscribe(data => {
          this.recurringRes = data;
          this.service.recurringRes.next(this.recurringRes)
          this.router.navigate(['admin/showRules']);
        })
      }

    }


  }
  cancel() {
    this.router.navigate(['admin/showRules']);
  }

}
